const es = {
  'n.comments.1': '{qty} comentario',
  'n.comments.other': '{qty} comentarios',
  'n.reactions.1': '{qty} reacción',
  'n.reactions.other': '{qty} reacciones',
};

export default es;
